import { AlertProps, Alert } from '@mui/material'

export function CustomAlert(props: AlertProps): JSX.Element {
  return <Alert elevation={6} variant="filled" {...props} />
}
